export interface SupportedLanguage {
  /** ISO 639-1 code used by i18next */
  code: string;
  /** Native label shown in the switcher menu */
  label: string;
  /**
   * Short uppercase code — ISO 639-1 en majuscules. C'est ce que les trois
   * sélecteurs affichent, dans le déclencheur compact ET devant le nom natif.
   *
   * IL A REMPLACÉ LE DRAPEAU EMOJI. Le client a demandé « pas d'emoji » et
   * « abréviation, FR, EN, … » sur les trois surfaces (Notion → Onboarding →
   * Lang, → Side bar → Personal settings, → Landing → Lang selection). Ce n'est
   * pas qu'une préférence graphique : un drapeau nomme un PAYS, pas une langue.
   * 🇬🇧 pour l'anglais et 🇪🇸 pour l'espagnol excluaient au passage la moitié des
   * gens qui les parlent, et les deux glyphes ne se rendaient pas de la même
   * façon d'un système à l'autre.
   */
  short: string;
}

/**
 * The languages the product actually speaks — the ONLY list the switchers read.
 *
 * A locale earns its place here when its catalogue is complete against `fr`
 * (the reference) and its interpolations match; `npm run audit:i18n -- --strict`
 * is the gate that says so, and it reads THIS list.
 */
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: 'fr', label: 'Français', short: 'FR' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'es', label: 'Español', short: 'ES' },
];

/**
 * DORMANT — translated in part, NOT offered in the switcher.
 *
 * `de` and `it` sat at 1 044 of 2 295 leaf keys: 639 missing each, three whole
 * namespaces absent (`chats`, `legalpages`, `os-shell`). A visitor who picked
 * Deutsch got a German shell over French pages — worse than never offering it,
 * because it reads as a broken product rather than an untranslated one.
 *
 * The JSON stays on disk and i18next still loads it (`import.meta.glob` walks
 * `locales/*`), so re-lighting a language is exactly this: complete the
 * catalogue, have a native speaker read it, move the entry back up. Nothing to
 * re-translate, nothing to re-import.
 */
export const DORMANT_LANGUAGES: SupportedLanguage[] = [
  { code: 'de', label: 'Deutsch', short: 'DE' },
  { code: 'it', label: 'Italiano', short: 'IT' },
];

export const DEFAULT_LANGUAGE = 'fr';
